// from crm_ui/tasks/constants/MarketPlaceAppIntegrationIds.js
import enviro from 'enviro';
const LINKED_IN_SALES_NAVIGATOR_APP_ID = 42082;
const QA_LINKED_IN_SALES_NAVIGATOR_APP_ID = 1161054;
export const getLinkedInSalesNavigatorId = () => {
  return enviro.isProd() ? LINKED_IN_SALES_NAVIGATOR_APP_ID : QA_LINKED_IN_SALES_NAVIGATOR_APP_ID;
};